import React, { useState } from 'react';
import Slider from 'react-slick';
import Flip from 'react-reveal/Flip';
import Fade from 'react-reveal/Fade';
import { allSliders } from '../data/Slider';
import { AiFillPlayCircle } from 'react-icons/ai';
import Modal from 'react-modal';
import { VideoModal } from './VideoModal';

const settings = {
  autoplay: true,
  autoplaySpeed: 7000,
  dots: true,
  infinite: true,
  speed: 1000,
  slidesToShow: 1,
  slidesToScroll: 1,
};
const HeroSection = () => {
  const [isOpen, setOpen] = useState(false); // Modal

  Modal.setAppElement(`#___gatsby`);

  const closeModal = () => {
    setOpen(false);
  };

  return (
    <section className='home-header'>
      <div className='slider-container'>
        <VideoModal isOpen={isOpen} closeModal={closeModal} />
        <Slider {...settings}>
          {allSliders.map((slider, i) => (
            <div className={`slide slide${i}`} key={i}>
              <div className='slide-image' style={{ backgroundImage: `url(${slider.image})` }}>
                <div className='container slider-content'>
                  <Flip right>
                    <button onClick={() => setOpen(true)} className='YouTubePlay'>
                      <AiFillPlayCircle className='icon' />
                      <span className='text'>Play Video</span>
                    </button>
                  </Flip>
                  <div className='text-contents'>
                    <Fade top>
                      <h1>
                        {slider.title1} <br /> {slider.title2}
                      </h1>
                    </Fade>
                    <Fade right>
                      <p>{slider.desc} </p>
                    </Fade>
                  </div>
                  {/* <Fade bottom>
                    <div className='buttons'>
                      <button className='btn'>
                        <Link to='/services'>Our Services </Link>
                      </button>
                      <button className='btn'>
                        <Link to='/contact'>
                          <FaTelegram className='icon' /> Contact Us{' '}
                        </Link>
                      </button>
                    </div>
                  </Fade> */}
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </section>
  );
};

export default HeroSection;
